import { Component, OnInit } from '@angular/core';
// import { RxStompService } from '@stomp/ng2-stompjs';
import { AuditUpdate } from '../audit-update';
import { AuditUpdateService } from '../service/audit-update.service';
import { HttpService } from '../service/http.service';

@Component({
  selector: 'app-last-updates',
  templateUrl: './last-updates.component.html',
  styleUrls: ['./last-updates.component.css']
})
export class LastUpdatesComponent implements OnInit {

  updateAudits: AuditUpdate[] = [];
  updateMessages: string[] = [];

  constructor(
    // private stompService: RxStompService,
    private auditUpdateService: AuditUpdateService,
    private httpService: HttpService,
  ) { }

  ngOnInit(): void {
  }

  getLastUpdates() {
    this.httpService.getLastUpdateHistory(10).subscribe(res => {
      this.updateAudits = res;
      for (let audit of res) {
        this.updateMessages.push(this.auditUpdateService.toUpdateString(audit));
      }
      // this.stompService.watch("/topic/news").subscribe(stompObject => {
      //   let update = JSON.parse(stompObject.body) as AuditUpdate;
        // this.updateAudits.unshift(update);
      });
    // });
  }

}
